import { IconV2 } from 'components/common/IconV2/IconV2';
import type { SmallIconV2Props } from 'components/common/IconV2/IconV2.types';

const WarningFilledSmallIcon = (props: SmallIconV2Props) => (
  <IconV2 {...props} viewBox="0 0 16 16">
    <path
      fill="currentcolor"
      fillRule="evenodd"
      d="M6.845 2a1.333 1.333 0 0 1 2.31 0l6.35 11c.513.889-.128 2-1.155 2H1.65a1.333 1.333 0 0 1-1.155-2zm2.03 10.125a.875.875 0 1 0-1.75 0 .875.875 0 0 0 1.75 0M8.6 9.5a.6.6 0 0 1-1.2 0v-3a.6.6 0 0 1 1.2 0z"
      clipRule="evenodd"
    />
  </IconV2>
);

export default WarningFilledSmallIcon;
